export default __webpack_public_path__ + "static/media/ReportIcon-Dental-MS.92999fbd.jpg";